module.exports = __webpack_public_path__ + "img/prodia-panorama-frimy.377bb673.jpg";